export default __webpack_public_path__ + "static/media/KarateBaby.1f2a4ff7.gif";